module.exports = __webpack_public_path__ + "static/media/kz.f0a24c9d.png";